import React, { FunctionComponent } from "react";
import { AdminConsole } from "./component";
import { useUser } from "../../hooks/session";
import { NotFoundPage } from "../NotFound";

export const AdminConsoleContainer: FunctionComponent = () => {
  const [currentUser] = useUser.useState();
  return currentUser?.role == "admin" ? <AdminConsole /> : <NotFoundPage />;
};
